// extracted by mini-css-extract-plugin
module.exports = {"fieldItem":"FieldItem_fieldItem__1P9kG","label":"FieldItem_label__1QOES","value":"FieldItem_value__34KoW"};